import { MediaImage } from 'components/templates/media/media--image';
import {Button} from "@/components/atoms/button";
import {useRouter} from "next/router";
import {Hero} from "@/components/organisms/hero";
import {FrostedGlassContainer} from "@/components/atoms/gradient-container";
import dynamic from "next/dynamic";
import {getEventDateLabel} from "@/lib/get-event-date-label";
import {useContext} from "react";
import {Dictionary} from "@/types/hygiena-types";
import {DictionaryContext} from "@/context/dictionary-context";
import {CONTACT_PORTAL_ID} from "@/lib/constants";

const ContentEventLower = dynamic(() => import("../../templates/nodes/content/content--event").then((mod) => mod.ContentEventLower));
const ContentEvent = dynamic(() => import("../../templates/nodes/content/content--event").then((mod) => mod.ContentEvent));

export function NodeEvent({ node, date = "", categoryTerm = null, additionalContent, layout, ...props }) {
  const t = useContext<Dictionary>(DictionaryContext);
  const {locale} = useRouter();

  /**
   * @todo refactor this, it's defined in a lot of different components.
   *
   * @param id
   */
  function scrollToSection(id: string) {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({behavior: 'smooth'})
    }
  }

  return (
    <>
      <article {...props}>
        <Hero image={node?.field_event_hero_image}>
          <FrostedGlassContainer className="p-8 w-full">
            <div className="flex gap-4 md:gap-12 items-center max-md:flex-wrap">
              <MediaImage
                height={150}
                width={150}
                className="max-md:w-full w-[150px] h-[150px]"
                childClass="h-[150px] w-[150px] max-w-none"
                style={{margin: "auto"}}
                media={node?.field_event_image}/>
              <div>
                {!node?.field_event_remove_join_us && (
                  <p className="m-0 text-xl font-bold text-primary">
                    {`${t?.all?.join_us}`}
                  </p>
                )}
                <h1 className="py-2 !font-normal md:leading-tight">
                  {node.title}
                </h1>
                <p className="text-gray-600 text-xl font-bold pb-0 mb-0">
                  {date && <span>{getEventDateLabel(node, locale, true)}</span>}
                </p>
                {node?.field_event_location?.length ? (
                  <p className="text-gray-600 text-xl mb-0">
                    {node.field_event_location}
                  </p>
                ): <></>}
                {!node?.field_event_remove_meet_us_here && node?.field_event_booth_details && (
                  <p className="text-gray-600 text-xl p-0">
                    {node.field_event_booth_details}
                  </p>
                )}
              </div>
            </div>
            <div className="mt-8 flex gap-2 flex-wrap">
              {!node?.field_event_disable_default && (
                <>
                  <Button containerClassName="w-full md:w-auto" className="w-full md:w-auto" callback={() => scrollToSection("event-header")} icon={"arrow-down"} position={"right"} color={"primary"} hover={{color: "primary"}} height={20} width={20}>{t?.all?.see_what_we_will_offer}</Button>
                  <Button containerClassName="w-full md:w-auto" className="w-full md:w-auto" callback={() => scrollToSection(CONTACT_PORTAL_ID)} icon={"arrow-down"} position={"right"} color={"primary"} hover={{color: "primary"}} height={20} width={20}>{t?.all?.schedule_meeting}</Button>
                </>
              )}
              {node?.field_event_buttons?.length ? (
                <>
                  {node.field_event_buttons.map((item, index) => {
                    if (!item.url.match(/^#/)) {
                      return <Button key={`event-hero-button--${index}`} containerClassName="w-full md:w-auto" className="w-full md:w-auto" href={item.url} color={"primary"} hover={{color: "primary"}} height={20} width={20}>{item?.title}</Button>
                    }
                    return <Button key={`event-hero-button--${index}`}  containerClassName="w-full md:w-auto" className="w-full md:w-auto" callback={() => scrollToSection(item.url.replace(/^#/, ""))} icon={"arrow-down"} position={"right"} color={"primary"} hover={{color: "primary"}} height={20} width={20}>{item.title}</Button>
                  })}
                </>
              ): <></>}
            </div>
          </FrostedGlassContainer>
        </Hero>
        <ContentEvent node={node} additionalContent={additionalContent} layout={layout} {...props}/>
      </article>
      <ContentEventLower node={node} additionalContent={additionalContent} {...props} />
    </>
  );
}